<template>
    <div class="product_price_collapse-wrapper">
        <div class="product_price_collapse-container" :class="{open : !isOpen}">

            <div @click="isOpen = !isOpen" class="title-container">
                <h2 class="title">
                    <span class="name">{{translate("fan")}}</span>
                    <transition name="fade">
                        <span v-if="!isOpen && countSimilarFans > 0" v-html="getActiveFun.type" class="model"/>
                    </transition>
                </h2>
                <div class="plus_icon">
                    <transition name="fade">
                        <span v-if="!isOpen" class="additional_text">{{translate("know_price")}}</span>
                    </transition>
                </div>
            </div>

            <div class="content">
                <div class="img-container">
                    <img v-if="countSimilarFans > 0" :src="'data:image/png;base64, ' + getActiveFun.src">
                    <span class="no-chosen" v-if="countSimilarFans == 0">{{translate("no_result")}}</span>
                </div>
                <span v-if="countSimilarFans > 0" v-html="getActiveFun.type" class="model"/>
                <span v-if="countSimilarFans > 0" class="text">
                    {{translate('price')}}: <span v-if="isLogged && getActiveFun.params.price > 0 && !temperatureCondition">{{$priceController.convertWithThousandSeparator(calculateDiscount(getActiveFun.params.price))}} EUR</span>
                    <span v-else>-</span>
                </span>
            </div>

            <div class="bottom" :class="{logged: isLogged}">
                <transition name="fade">
                    <router-link to="/login">
                        <span v-if="!isLogged" class="login-link">{{translate("log_in_to_see")}}</span>
                    </router-link>
                </transition>
            </div>
        </div>

        <transition name="fade">
            <div v-if="!isLogged" class="register-link" :class="{visible : isOpen}">
                <span class="text">Nie masz konta?&nbsp;</span>
                <router-link to="/register"><span class="link">Zarejestruj się.</span></router-link>
            </div>
        </transition>

    </div>
</template>

<script>
    export default {
        name: "ProductPriceCollapse",
        data() {
            return {
                isOpen: false
            }
        },
        props: ['temperatureCondition'],
        methods: {
            calculateDiscount(price){
                return parseFloat(this.$priceController.calculateDiscount(price, this.$store.state.discount)).toFixed(2).toString();
            },

            translate(code, displayErrors = true) {
                let arg = {
                    type: 'translate',
                    code: code,
                    displayErrors: displayErrors,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },

            manageSelectedFan(){
                this.$store.commit({
                    type: 'manageSelectedFan',
                });
            }
        },
        computed: {

            getActiveFun() {
                return this.$store.state.activeFun;
            },

            isLogged() {
                return this.$store.getters.getIfUserLogged;
            },

            countSimilarFans() {
                this.manageSelectedFan();

                if (this.$store.state.fansTableData.FanTableRef)
                    return this.$store.state.fansTableData.FanTableRef.allFilteredData.length;
                else
                    return 0;
            }
        }
    }
</script>

<style scoped lang="scss">
    .fade-enter, .fade-leave-to {
        opacity: 0;
        padding-bottom: 0;
    }
</style>
